import React from 'react';
import BookmarkFillIcon from '@tradera/blueprint/theme/icons2/bookmark-fill.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons/close-narrow.svg?jsx';

export const SaveSearchHintTooltip = ({ onClick, title, text }) => (
    <span
        role="tooltip"
        className="tooltip tooltip-southwest"
        onClick={() => onClick()}>
        <div className="tooltip_html py-1">
            <BookmarkFillIcon className="tooltip_icon icon icon-branded" />
            <span className="tooltip_content" style={{ width: '245px' }}>
                <p className="text-branded mb-1">{title}</p>
                <span>{text}</span>
            </span>
            <span className="tooltip_close-icon">
                <CloseIcon className="icon icon-sm" />
            </span>
        </div>
    </span>
);
